import { Guid, Nillable } from '@web/utils';
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { WarehouseReleaseStatus } from '../../enums/warehouse-release-status';
import { WarehouseReleaseContextOperationsResponse } from './warehouse-release-context-operations.response';

@jsonObject
export class WarehouseReleaseDetailsResponse {
  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly approvedAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly rejectedAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly releasedAt!: Date;

  @jsonMember(String)
  public readonly comment!: Nillable<string>;

  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly status!: WarehouseReleaseStatus;

  @jsonMember(WarehouseReleaseContextOperationsResponse)
  public readonly contextOperations!: WarehouseReleaseContextOperationsResponse;

  @jsonArrayMember(MultimediaResponse)
  public readonly files!: MultimediaResponse[];
}
